class Product {
    constructor(){
        this.handle = '';
    }
  
    init() {
      document.addEventListener('DOMContentLoaded', async function() {
  
        ProductInstance.ApplyPostalCodeMask('input[name="product-shipping-postalcode"]');
  
  
        const buttonShipping = document.getElementById('button-product-shipping');
        buttonShipping.addEventListener('click', async function(el){
          const postalCode = document.getElementById('product-shipping-postalcode').value;
          const shippingOptionsElement = document.querySelector('.product-shipping-options');
            
            // Validações adicionais
            if(postalCode.length != 9) {
                ProductInstance.ToastMessages(400);
                shippingOptionsElement.classList.add('d-none');
                shippingOptionsElement.classList.remove('d-flex');
                return false;
            }

          const productHandle = document.getElementById('product-shipping-postalcode').dataset.handle;
          const quantity = document.querySelector('input[name=quantity]').value;
          
          if(postalCode != "" && postalCode != undefined) {
            const product = await ProductInstance.GetProduct(productHandle);
            const shippingRates = await ProductInstance.CalculateShipping(postalCode, product, quantity);
            if(shippingRates.status && shippingRates.status === 200 && shippingRates.data && shippingRates.data.length > 0) {
                var shippingHTML = '';
                for (const element of shippingRates.data) {
                    console.log(element);
                
                    const price = await ProductInstance.FormatPrice(element.total_price);
                
                    let html = `\
                        <div class="product-shipping-options-item">\
                        <span>${element.service_code}</span>\
                        <span>${price}</span>\
                        </div>\
                    `;
                
                    console.log(html);
                
                    shippingHTML += html;
                }

                console.log(shippingHTML);

                shippingOptionsElement.innerHTML = shippingHTML;
                shippingOptionsElement.classList.remove('d-none');
                shippingOptionsElement.classList.add('d-flex');
             
            } else {
                ProductInstance.ToastMessages(500);
                shippingOptionsElement.classList.add('d-none');
                shippingOptionsElement.classList.remove('d-flex');
            }
          } else {
            ProductInstance.ToastMessages(401);
            shippingOptionsElement.classList.add('d-none');
            shippingOptionsElement.classList.remove('d-flex');
          }
        }); 
       
      });
    }

    async GetProduct(handle) {
        const response = await fetch(`/products/${handle}.js`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
          });
          const product = await response.json();
          return product;
    }
  
    async CalculateShipping(postalCode, productData, quantity) {
        var response = "";

        const headers = new Headers();
        headers.append("Content-Type", "application/json");

        const product = {
            "product": productData.id,
            "variant": productData.variants[0].id,
            "weight": productData.variants[0].weight,
            "quantity": parseInt(quantity),
            "postalcode": postalCode,
            "store": "DKT"
        }

        try {
            const response = await fetch(`https://kdgvkpha0l.execute-api.us-east-1.amazonaws.com/shopify/shipping`, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(product),
                redirect: "follow"
            });
    
            const data = await response.json();
    
            if (response.ok && data.data && data.data.rates && data.data.rates.length > 0) {
                return {
                    status: 200,
                    data: data.data.rates
                };
            } else {
                return {
                    status: 400,
                    data: ''
                };
            }
    
        } catch (error) {
            console.error('Error:', error);
            return {
                status: 500,
                data: ''
            };
        }
    }

    async FormatPrice(value) {
        value = value / 100;
        value = value.toFixed(2).toString();
        if(value == '0') value = '0.00';
        return 'R$ ' + value.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
  
    ApplyPostalCodeMask(field) {
        const postalCodeInput = document.querySelector(field);
        if (postalCodeInput) {
            const applyMask = (event) => {
                let value = event.target.value;
                value = value.replace(/\D/g, '');
                value = value.replace(/^(\d{5})(\d)/, '$1-$2'); 
                event.target.value = value;
            };
    
            postalCodeInput.addEventListener('input', applyMask);
            postalCodeInput.addEventListener('keyup', applyMask);
        } else {
            console.warn(`Elemento com o seletor ${field} não foi encontrado.`);
        }
    }

    ToastMessages(code) {

        // Variáveis
        var message = "";
        var type = "";

        // Seleciona o erro de acordo com o código
        switch(code){
            case 400: message = "CEP Inválido"; type = "toast-failed"; break;
            case 401: message = "Não entrega disponível para sua localização"; type = "toast-failed"; break;
            case 500: message = "Ocorreu um erro ao realizar ao realizar a consulta, por favor tente mais tarde!"; type = "toast-failed"; break;
        }

        // Obtém os elementos HTML
        const toast = document.getElementById('toast');
        const toast_message = toast.querySelector('#toast-message');

        // Adiciona a mensagem ao toast
        toast_message.innerHTML = message;

        // Inicializa o toast e aguarda 6 segundos para fechar
        toast.classList.add(type);
        setTimeout(() => {
            toast.classList.remove(type);
        }, 6000);
    }
  
  }
  
  const ProductInstance = new Product;
  ProductInstance.init();